import angular from 'angular';
import _ from "lodash";

const merchantProfileFactory = function merchantProfileFactory($q, $log, $http, endPoints, $state, $rootScope, JsonLoaderService, $timeout, $filter, StorageService, NewBackendService, Environment, NewTokenService, MerchantProfileStore, Dispatcher) {
        "ngInject";
      const serviceObject = {
        getMerchantProfile: (isBackground, getAllContext = false, businessId) =>{
          return $q(function(resolve, reject){
                businessId = businessId ? businessId : "me";
                if (businessId === "me") {
                  let userContext = localStorage.getItem("userContext");
                  if (userContext) {
                    businessId = JSON.parse(userContext).id
                  }
              }
                NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/users/${businessId}`, {}, isBackground).then(
                function(resp) {
                  const context = resp.data;
                  Dispatcher.dispatch({
                    actionType: "UPDATE_MERCHANT_PROFILE",
                    data: context,
                    state: "STORE_PENDING_UPDATE"
                  });
                  if(getAllContext){
                    const output = resp.data;
                    resolve(output);
                  } else {
                    resolve(context);
                  }
                },
                function(reason) {
                  $log.error('Get merchant profile failed: ', reason);
                  reject(reason);
                }
            );
          })
        },

      getMerchantBusiness: (businessId, merchantId) => {
        return $q(function(resolve, reject){
          merchantId = merchantId ? merchantId : "me";

          // Try to resolve merchantId using the storage
          if (merchantId === "me") {
            let userContext = localStorage.getItem("userContext");
            if (userContext) {
              merchantId = JSON.parse(userContext).id

            }
          }

          // Try to resolve businessId using the storage
          if (businessId === false) {
            let merchantDeviceData = localStorage.getItem("userContext");
            if (merchantDeviceData) {
              businessId = JSON.parse(merchantDeviceData).business.id
            }
        }
          NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/users/${merchantId}/businesses/${businessId}`, {}, false).then(
            function(resp) {
              resolve(resp);
            },
            function(reason) {
                  $log.error('Get merchant business failed: ', reason);
                  reject(reason);
            }

          )
        })
      },

        setProfileDefault: (value) => {
            return $q(function(resolve, reject){

                      const req  = {

                        "data": {
                          "request": {
                            "setProfiloDefaultRequest": {
                              "newProfiloDefault": value
                            }
                          }
                        }
                      };

                    NewBackendService.invokeWebApiPost("user/setProfiloDefault", req, true, true).then(
                      function(resp) {
                          NewTokenService.setProfileDefaultinStorage(value);
                          resolve(resp);

                      },
                      function(reason) {
                        $log.error('Set Profilo Default Failed: ', reason);
                        reject(reason);

                      }
                    );

            });
        },
        changeInsignia: (insegna, isBackground) =>{
          return $q(function (resolve, reject){
            NewBackendService.invokeWebApiPost(url, request, isBackground).then(function (result) {
              resolve(result.data);
            }, function (error) {
              reject(error);
            });
          });
        },
      };
      return serviceObject;
    };


export default merchantProfileFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantProfile.factory.js
 **/